import { PLAN_STATUS } from "../constants/planStatus"

export const getFromPlanContent = (plan, key) => {
  const content = plan?.content ?? [];
  return content.find(item => item.key == key)?.value ?? "";
}

export const getPlanStudentFirstName = (plan) => {
  if (plan?.youth && plan.youth.length > 0) return plan.youth[0]?.first_name
  const fromContent = getFromPlanContent(plan, "student_first_name")
  if (fromContent) return fromContent
  return plan?.initiator?.[0]?.first_name ?? ""
}

export const getPlanStudentLastName = (plan) => {
  if (plan?.youth && plan.youth.length > 0) return plan.youth[0]?.last_name
  const fromContent = getFromPlanContent(plan, "student_last_name")
  if (fromContent) return fromContent
  return plan?.initiator?.[0]?.last_name ?? ""
}

export const getPlanStudentEmail = (plan) => {
  if (plan?.youth && plan.youth.length > 0) return plan.youth[0]?.email
  return getFromPlanContent(plan, "student_email")
}

export const getGuardianEmail = (plan) => {
  return getFromPlanContent(plan, "guardian_email")
}

export const getGuardianFirstName = (plan) => {
  return getFromPlanContent(plan, "guardian_first_name")
}

export const getGuardianLastName = (plan) => {
  return getFromPlanContent(plan, "guardian_last_name")
}

export const isStepLocked = (step, planStep) => {
  const steps = [
    PLAN_STATUS.CHOOSE_GUIDE,
    PLAN_STATUS.INVITE_STUDENT,
    PLAN_STATUS.SIT_WITH_STUDENT,
    PLAN_STATUS.INVITE_MENTORS,
    PLAN_STATUS.SEND_PLAN,
    PLAN_STATUS.CHECKLIST_COMPLETE,
    PLAN_STATUS.PLAN_COMPLETE
  ]
  const currentStepIndex = steps.indexOf(step);
  const planStepIndex = steps.indexOf(planStep);

  return currentStepIndex > planStepIndex;
}